import { render, staticRenderFns } from "./ExternalBrokerList.vue?vue&type=template&id=065b8794"
import script from "./ExternalBrokerList.vue?vue&type=script&lang=js"
export * from "./ExternalBrokerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports